import React from 'react';
import {
  HStack, Text, Pressable, Icon, Box,
} from '@gluestack-ui/themed';
import { SidebarItemProps } from '../types';

/**
 * A single item in the lecturer sidebar navigation.
 */
const SidebarItem: React.FC<SidebarItemProps> = ({
  icon: IconComponent,
  label,
  isActive,
  onPress,
  badge = 0,
  badgeText,
  hasOverdue = false,
  isCollapsed = false,
  disabled = false,
}) => (
  <Pressable
    onPress={disabled ? undefined : onPress}
    p="$2.5"
    px="$4"
    my="$0.5"
    borderLeftWidth={!isCollapsed && isActive ? 3 : 0}
    borderLeftColor={isActive ? '$accent600' : 'transparent'}
    opacity={disabled ? 0.4 : (isActive ? 1 : 0.8)}
    alignItems="center"
    justifyContent="center"
    disabled={disabled}
  >
    <HStack alignItems="center" space={isCollapsed ? undefined : 'md'} justifyContent={isCollapsed ? 'center' : 'flex-start'} w="100%">
      <Icon as={IconComponent} size={isCollapsed ? 'md' : 'sm'} color={disabled ? '$textHint' : (isActive ? '$accent700' : '$textSubtle')} />
      {!isCollapsed && (
        <Text
          size="sm"
          fontWeight={isActive ? '$semibold' : '$medium'}
          color={disabled ? '$textHint' : (isActive ? '$accent800' : '$textBody')}
          flex={1}
          numberOfLines={1}
        >
          {label}
        </Text>
      )}
      {!!badgeText && !isCollapsed && !disabled && (
        <Box
          bg="$bgBrandSubtle"
          borderWidth={1}
          borderColor="$borderBrand"
          borderRadius="$full"
          h={20}
          px="$2"
          alignItems="center"
          justifyContent="center"
        >
          <Text size="2xs" color="$textOnBrandSubtle" fontFamily="$heading">
            {badgeText}
          </Text>
        </Box>
      )}
      {badge > 0 && !disabled && (
        <Box
          bg={hasOverdue ? '$error600' : '$accent600'}
          borderRadius="$full"
          minWidth={isCollapsed ? 16 : 20}
          height={isCollapsed ? 16 : 20}
          px={isCollapsed ? '$0.5' : '$1.5'}
          alignItems="center"
          justifyContent="center"
          position={isCollapsed ? 'absolute' : 'relative'}
          top={isCollapsed ? -5 : 0}
          right={isCollapsed ? -5 : 0}
        >
          <Text size="2xs" fontWeight="bold" color="white">
            {badge}
          </Text>
        </Box>
      )}
    </HStack>
  </Pressable>
);

export default SidebarItem;
